import { inject, observer } from 'mobx-react';
import React from 'react'

@inject('workAreaStore', 'layerStore', 'sidebarStore') @observer
class ContextMenu extends React.Component {


  handleClick(actionId, e){
    const { workAreaStore, sidebarStore } = this.props
    const selectedLayer = workAreaStore.selectedLayer
    const zoom = workAreaStore.zoom / 100
    const { pageIdx } = workAreaStore.findLayerIdx(selectedLayer)
    const layer = workAreaStore.getSelectedLayer()
    switch(actionId){
      case 'delete':
        if(selectedLayer){
          if(layer && layer.type === 'text'){
            sidebarStore.closeSidebarSlide()
          }
          workAreaStore.deleteLayerById(selectedLayer)
        }
        break
      case 'copy':
        if(selectedLayer){
          workAreaStore.setCopiedLayer(selectedLayer)
        }
        break
      case 'set-bg':
        const page = workAreaStore.pages[pageIdx]
        if(page && layer && layer.type === 'photo' && !layer.photoType){
          const asset = {}
          if(layer.assetId){
            asset.assetId = layer.assetId
          }
          workAreaStore.changePageProp(page.id, 'backgroundUrl', layer.dataSource, asset)
        }
        break
      case 'paste':
        const pageIndex = workAreaStore.pages.findIndex(({ id }) => id === workAreaStore.activePage)
        const { clientX, clientY } = e
        const domContext = document.querySelector('.context-menu')
        let wrapper = document.querySelector('.layer.selected')
        if(workAreaStore.copiedLayer){
          wrapper = document.querySelector(`[data-id="${btoa(workAreaStore.copiedLayer.id)}"]`)
        }
        let top = 0
        let left = 0
        if(wrapper){
          const { top: lt, left: ll } = wrapper.getBoundingClientRect()
          top = lt
          left = ll
        }
        const xOffset = domContext.offsetWidth
        const yOffset = domContext.offsetHeight
        let x = clientX - (left / 2) - (xOffset / 2)
        let y = clientY - (top / 2) - (yOffset / 2)
        const rect = domContext.getBoundingClientRect()
        if(!wrapper && workAreaStore.cutLayer){
          x = (rect.left / 2) * zoom
          y = rect.top * zoom
        }
        workAreaStore.duplicateLayer(x / zoom, y / zoom, pageIndex, !!workAreaStore.cutLayer)
        break
      case 'front':
        workAreaStore.shiftLayerIndex(selectedLayer, true, pageIdx)
        break
      case 'back':
        workAreaStore.shiftLayerIndex(selectedLayer, false, pageIdx)
        break
      case 'front-full':
        workAreaStore.shiftLayerFully(selectedLayer, true, pageIdx)
        break
      case 'back-full':
        workAreaStore.shiftLayerFully(selectedLayer, false, pageIdx)
        break
      case 'group':
        if(layer && layer.type === 'group'){
          workAreaStore.createFinalGroup()
        }
        if(layer && layer.type === 'svgGroup'){
          console.log('create SVG group')
        }
        break
      case 'ungroup':
        if(layer && layer.type === 'group'){
          workAreaStore.ungroupItems()
        }
        if(layer && layer.type === 'svgGroup'){
          workAreaStore.ungroupSVGGroup(layer)
        }
        break
      default:
        break
    }
    workAreaStore.toggleContextMenu(0, 0, false)
  }

  render(){
    const { actions, xPos, yPos, workAreaStore } = this.props
    const zoom = workAreaStore.zoom / 100
    const classExt = {
      1: 'context-group-1',
      2: 'context-group-2',
      3: 'context-group-3'
    }
    const iconSize = 20 / zoom
    const w = 170 / zoom
    const fs = 15 / zoom
    const radius = 8 / zoom
    const itemPadding = 5 / zoom
    return (
      <div 
        className="context-menu"
        style={{
          top: yPos / zoom,
          left: xPos / zoom,
          width: `${w}px`,
          borderRadius: radius + 'px'
        }}
      >
        {
          actions.map(action => {
            const { group } = action
            const className = 'context-menu__item ' + classExt[group]
            return (
              <div 
                style={{
                  padding: `${itemPadding}px`
                }}
                key={action.id}
                onClick={e => this.handleClick(action.id, e)}
                className={className}>
                <div
                  className="context-menu__icon"
                  style={{
                    width: `${iconSize}px`,
                    height: `${iconSize}px`,
                    padding: `${2.5 / zoom}px`
                  }}
                >
                  {action.icon}
                </div>
                <label 
                  style={{
                    fontSize: `${fs}px`
                  }}
                  className="context-menu__item__label">
                  {action.label}
                </label>
              </div>
            )
          })
        }
      </div>
    )
  }

}

export default ContextMenu